<template>
    <div>
        <div v-for="(email, i) in emails">
            <div class="row mb-1">
                <div class="col-12">
                    <b-form-input v-model="email.email" size="sm" type="email" placeholder="Enter Email" :class="{'is-invalid': errors['emails.'+i+'.email']}" />
                </div>
            </div>

            <div class="row mb-1">
                <div class="col-6">
                    <b-form-radio v-model="is_primary" name="primary_email" :value="email.email" plain><span>Primary</span></b-form-radio>
                </div>
                <div class="col-6 text-right">
                    <a href="javascript:void(0)" class="text-danger" v-on:click="deleteEmail(i)"><i class="fa fa-trash"></i> Delete</a>
                </div>
            </div>

            <div class="text-danger mt-1" v-if="errors['emails.'+i+'.email']">
                <ul class="list-unstyled mb-0">
                    <li v-for="err in errors['emails.'+i+'.email']">{{ err }}</li>
                </ul>
            </div>

            <hr v-if="i < (emails.length - 1)" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            emails: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                errors: {},
                is_primary: null,
            }
        },

        watch: {

        },

        computed: {

        },

        methods: {
            addEmail(){
                //Push
                this.emails.push({email: '', is_primary: 0});
            },

            deleteEmail(i){
                //Confirm
                if(!confirm('Are you sure you want to delete this email: '+this.emails[i].email))
                {
                    return;
                }

                //Splice
                this.emails.splice(i, 1);
            },

            getEmails(){
                //Set primary
                for (var i = this.emails.length - 1; i >= 0; i--)
                {
                    if(this.emails[i].email === this.is_primary)
                    {
                        this.emails[i].is_primary = 1;
                    }
                    else
                    {
                        this.emails[i].is_primary = 0;
                    }
                }

                //Get the emails
                return this.emails;
            },

            setErrors(errors){
                //Set the errors
                this.errors = errors
            },

            setPrimary(){
                //Set primary
                for (var i = this.emails.length - 1; i >= 0; i--)
                {
                    if(this.emails[i].is_primary == 1)
                    {
                        this.is_primary = this.emails[i].email;
                    }
                }
            },

        },

        mounted() {
            this.setPrimary();
        }
    }
</script>
